import { CustomerServiceOffering } from '@sales/modules/details/models/customer-service-offering.model';
import { Selector } from '@ngxs/store';
import { CustomerServiceProductsStateModel, CustomerServiceProductState } from './customer-service-product.state';
import { CustomerServiceOfferingType } from '@sales/models/customer-service-offering-type';
import { CustomerServiceType } from '@sales/models/customer-service-type.enums';
import { CustomerServiceProduct } from '@shared/models/customer-service-product';
import { MobileInsuranceAgreement } from '@sales/modules/mobilephone/models/mobile-insurance-agreement';
import { CustomerSelectors } from '@sales/modules/details/states/customer.selectors';
import { CustomerEquipment } from '@sales/modules/details/models/customer-equipment';
import { AssignedCustomerServiceModel } from '@app/sales/modules/details/models/assigned-customer-services.model';

export class CustomerServiceProductSelectors {
  @Selector([CustomerServiceProductState])
  static getIsLoadingAssignedCustomerServiceProducts(state: CustomerServiceProductsStateModel): boolean {
    return state.isLoadingAssignedCustomerServiceProducts;
  }

  @Selector([CustomerServiceProductState])
  static getAssignedCustomerServiceProducts(state: CustomerServiceProductsStateModel): AssignedCustomerServiceModel[] {
    return state.assignedProducts;
  }

  @Selector([CustomerServiceProductState])
  static getCustomerServiceProductsAdded(state: CustomerServiceProductsStateModel): CustomerServiceProduct[] {
    return state.addedProducts;
  }

  @Selector([CustomerServiceProductState])
  static getAvailableIceTryggStandaloneForCustomer(state: CustomerServiceProductsStateModel): CustomerServiceOffering {
    return state.availableCustomerServiceOfferingsForCustomer.find(
      p => p.serviceType === CustomerServiceOfferingType.IceTryggStandalone
    );
  }

  @Selector([CustomerServiceProductState])
  static getIceTryggStandaloneForNewVoiceCustomer(state: CustomerServiceProductsStateModel): CustomerServiceOffering {
    return state.allCustomerServiceOfferings.find(p => p.serviceType === CustomerServiceOfferingType.IceTryggStandalone);
  }

  @Selector([CustomerServiceProductState])
  static getIsLoadingAvailableCustomerServiceOfferings(state: CustomerServiceProductsStateModel): boolean {
    return state.isLoadingAvailableCustomerServiceOfferings;
  }

  @Selector([CustomerServiceProductState])
  static getIceTryggStandaloneAddedProduct(state: CustomerServiceProductsStateModel): CustomerServiceProduct {
    return state.addedProducts.find(
      p =>
        !p.isExistingSubscription &&
        p.customerServiceOffering?.serviceType === CustomerServiceOfferingType.IceTryggStandalone
    );
  }

  @Selector([CustomerServiceProductState])
  static isIceTryggStandaloneActive(state: CustomerServiceProductsStateModel): boolean {
    return state.assignedProducts.some(p => p.isActive && p.serviceType === CustomerServiceType.IceTryggStandalone);
  }

  @Selector([CustomerServiceProductState, CustomerSelectors.customerEquipment])
  static getAssignedMobileInsurances(
    state: CustomerServiceProductsStateModel,
    customerEquipment: CustomerEquipment[]
  ): MobileInsuranceAgreement[] {
    let insuranceServices = state.assignedProducts.filter(p => p.isActive && p.mobileInsurance);
    return insuranceServices.map(service => {
      return {
        assignedInsurance: service,
        equipment: customerEquipment.find(e => e.imei === service.mobileInsurance.insuredIMEI),
      } as MobileInsuranceAgreement;
    });
  }

  @Selector([CustomerServiceProductState])
  static getNettslettCustomerServiceProduct(state: CustomerServiceProductsStateModel): AssignedCustomerServiceModel {
    return state.assignedProducts.find(p => p.isActive && p.serviceType === CustomerServiceType.Nettslett);
  }

  @Selector([CustomerServiceProductState])
  static hasIceTryggStandalone(state: CustomerServiceProductsStateModel): boolean {
    return (
      state.addedProducts.some(
        p =>
          !p.isExistingSubscription &&
          p.customerServiceOffering?.serviceType === CustomerServiceOfferingType.IceTryggStandalone
      ) || state.assignedProducts.some(p => p.isActive && p.serviceType === CustomerServiceType.IceTryggStandalone)
    );
  }
}
